var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51613 8.05556H8.45161V8.33333C8.45161 9.25278 9.14581 10 10 10H14.129C14.9832 10 15.6774 9.25278 15.6774 8.33333V8.05556H17.4839C17.7677 8.05556 18 7.80556 18 7.5C18 7.19444 17.7677 6.94444 17.4839 6.94444H15.6774V6.66667C15.6774 5.74722 14.9832 5 14.129 5H10C9.14581 5 8.45161 5.74722 8.45161 6.66667V6.94444H2.51613C2.23226 6.94444 2 7.19444 2 7.5C2 7.80556 2.23226 8.05556 2.51613 8.05556ZM9.48387 6.66667C9.48387 6.36111 9.71613 6.11111 10 6.11111H14.129C14.4129 6.11111 14.6452 6.36111 14.6452 6.66667V8.33333C14.6452 8.63889 14.4129 8.88889 14.129 8.88889H10C9.71613 8.88889 9.48387 8.63889 9.48387 8.33333V6.66667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4839 12.9444H11.5484V12.6667C11.5484 11.7472 10.8542 11 10 11H5.87097C5.01677 11 4.32258 11.7472 4.32258 12.6667V12.9444H2.51613C2.23226 12.9444 2 13.1944 2 13.5C2 13.8056 2.23226 14.0556 2.51613 14.0556H4.32258V14.3333C4.32258 15.2528 5.01677 16 5.87097 16H10C10.8542 16 11.5484 15.2528 11.5484 14.3333V14.0556H17.4839C17.7677 14.0556 18 13.8056 18 13.5C18 13.1944 17.7677 12.9444 17.4839 12.9444ZM10.5161 14.3333C10.5161 14.6389 10.2839 14.8889 10 14.8889H5.87097C5.5871 14.8889 5.35484 14.6389 5.35484 14.3333V12.6667C5.35484 12.3611 5.5871 12.1111 5.87097 12.1111H10C10.2839 12.1111 10.5161 12.3611 10.5161 12.6667V14.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.51d7a5dcfe8a6d1997f01205e23ac876.svg";
export { ForwardRef as ReactComponent };